import { useEffect, useState, useRef } from "react";
import TagCloud from "TagCloud";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Skill.scss";
import { Outlet } from "react-router-dom";
import { skillTags, skillSummary } from "../../data/profileData";

function Skill() {
  const [letterClass, setLetterClass] = useState("text-animate");
  const contentRef = useRef(null);

  useEffect(() => {
    const myTags = skillTags;

    const tagCloud = TagCloud(".content", myTags, {
      radius: 400,
      maxSpeed: "fast",
      initSpeed: "fast",
      direction: 135,
      keep: false,
    });

    let currentScale = 1;
    let ticking = false;

    const updateTransform = () => {
      if (contentRef.current) {
        contentRef.current.style.transform = `translateY(-50%) scale(${currentScale})`;
      }
      ticking = false;
    };

    const handleWheel = (e) => {
      e.preventDefault();

      const zoomSpeed = 0.0015;
      currentScale += e.deltaY * -zoomSpeed;

      currentScale = Math.min(Math.max(0.4, currentScale), 3);

      if (!ticking) {
        window.requestAnimationFrame(updateTransform);
        ticking = true;
      }
    };

    const sphereContainer = contentRef.current;
    if (sphereContainer) {
      sphereContainer.addEventListener("wheel", handleWheel, {
        passive: false,
      });
    }
    const timer = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);

    return () => {
      clearTimeout(timer);
      if (tagCloud && typeof tagCloud.destroy === "function") {
        tagCloud.destroy();
      }
      if (sphereContainer) {
        sphereContainer.removeEventListener("wheel", handleWheel);
      }
    };
  }, []);

  return (
    <>
      <div className="container skill-page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["S", "k", "i", "l", "l", "s", " ", "&"]}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["E", "x", "p", "e", "r", "i", "e", "n", "c", "e"]}
              idx={22}
            />
          </h1>
          <p>
            {skillSummary}
            <br />
            <br />
            • Languages: Java, Python, SQL, JavaScript, TypeScript
            <br />
            • AI Systems: GraphRAG, Semantic Retrieval, Knowledge Graphs,
            Retrieval Pipelines, Provenance, Context Engineering, Evaluation Frameworks
            <br />
            • Backend &amp; Distributed Systems: FastAPI, Flask, REST
            APIs, Microservices, Event-Driven Architecture, Message Queues
            <br />
            • Data &amp; Streaming: Apache Spark, Delta Lake,
            ETL Pipelines, PostgreSQL, MySQL, MongoDB, Redis, SPARQL
            <br />
            • Developer Tools: IntelliJ, VS Code, Git, Docker, Cursor,
            GitHub Actions, pytest
          </p>

          <div className="timeline-container">
            <div className="timeline-title">TIMELINE</div>

            <div className="timeline-content">
              <div
                className="timeline-company-fill morgan-stanley-fill"
                style={{ left: "10%", width: "88%" }}
              ></div>

              <div
                className="company-span"
                style={{ left: "10%", width: "88%" }}
              >
                <div className="company-name">AI Systems &middot; Backend &middot; Distributed</div>
                <div
                  className="company-line"
                  style={{ backgroundColor: "#9b5de5" }}
                ></div>
              </div>

              <div className="timeline-track">
                <div
                  className="timeline-bar-group"
                  style={{ left: "10%", width: "14%" }}
                >
                    <span className="timeline-label">ENTC</span>
                  <div
                    className="timeline-bar"
                    style={{ backgroundColor: "#00d2b5" }}
                  ></div>
                </div>

                <div
                  className="timeline-bar-group"
                  style={{ left: "24%", width: "14%" }}
                >
                    <span className="timeline-label">Backend</span>
                  <div
                    className="timeline-bar"
                    style={{ backgroundColor: "#e965d3" }}
                  ></div>
                </div>

                <div
                  className="timeline-bar-group"
                  style={{ left: "38%", width: "24%" }}
                >
                    <span className="timeline-label">Data / AI</span>
                  <div
                    className="timeline-bar"
                    style={{ backgroundColor: "#0a58e0" }}
                  ></div>
                </div>

                <div
                  className="timeline-bar-group"
                  style={{ left: "62%", width: "14%" }}
                >
                    <span className="timeline-label">Open Source</span>
                  <div
                    className="timeline-bar"
                    style={{ backgroundColor: "#fee440" }}
                  ></div>
                </div>

                <div
                  className="timeline-bar-group"
                  style={{ left: "78%", width: "20%" }}
                >
                    <span className="timeline-label">Semantica</span>
                  <div
                    className="timeline-bar"
                    style={{ backgroundColor: "#00bbf0" }}
                  ></div>
                </div>
              </div>
              <div className="timeline-axis">
                <span className="axis-tick" style={{ left: "0%" }}>
                  2023
                </span>
                <span className="axis-tick" style={{ left: "25%" }}>
                  2024
                </span>
                <span className="axis-tick" style={{ left: "50%" }}>
                  2025
                </span>
                <span className="axis-tick" style={{ left: "75%" }}>
                  2026
                </span>
                <span className="axis-tick" style={{ left: "100%" }}>
                  2027
                </span>
              </div>
            </div>
          </div>
        </div>
        <Outlet />
        <div ref={contentRef} className="content"></div>
        <div className="scroll-hint">Scroll here to zoom in and zoom out</div>
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </>
  );
}

export default Skill;